import { render, staticRenderFns } from "./SolicitorCaseDetailsDrawer.vue?vue&type=template&id=02296cfd"
import script from "./SolicitorCaseDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./SolicitorCaseDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports